<template>
    <q-input
    :dark="isDarkModeGlobal"
    dense
    label="Overall DC"
    readonly
    outlined
    type="number"
    step="0.000001"
    v-model="overallDC"
    hide-bottom-space
    hide-hint
  >
  </q-input>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia"
const calculatorStore = useCalculatorStore()
import { useCalculatorStore } from '../stores/calculator.store'

const {
  isDarkModeGlobal,
  overallDC
} = storeToRefs(calculatorStore)

</script>

